import { shouldForwardProp } from '@ori/presentation-utils';
import { styled } from '@ori-ui/mui';
import { getNavigationArrowFontSize, getNavigationArrowWidth } from "../utils";
export var PreviousArrow = styled('div', {
  name: 'CarouselPreviousArrow',
  slot: 'PreviousArrow',
  shouldForwardProp: shouldForwardProp()
})(function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return {
    cursor: 'pointer',
    height: '100%',
    left: '0px',
    position: 'absolute',
    textAlign: 'center',
    top: '0',
    width: getNavigationArrowWidth({
      size: size
    }),
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      transition: theme.transitions.create(['background-color'], {
        duration: theme.transitions.duration.short
      })
    },
    zIndex: 2,
    svg: {
      height: '100%',
      fontSize: getNavigationArrowFontSize({
        size: size
      })
    }
  };
});
export var NextArrow = styled(PreviousArrow, {
  name: 'CarouselNextArrow',
  slot: 'NextArrow',
  shouldForwardProp: shouldForwardProp()
})({
  left: 'unset',
  right: '0px'
});
//# sourceMappingURL=navigationArrows.js.map